export default "__VITE_ASSET__6t4X2F$___"